// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__qzL68","defaultBackgroundColor":"styles_defaultBackgroundColor__+2VBq"};